
/**
 * Classe responsável em manter o Menu Recente para aplicações no ambiente Cana.
 */
export class RecentsCaneDTO {

    aplicativo: string;
    form: string;
    child: string;
    path: string;
    usuario: string;

}